// dva model - 剧目销售看板
// 接口约定见 2026-09-01-show-sales-dashboard-frontend-api.md
// 入参：{ proNo, startDate, endDate }
// 出参 items[] -> utils/apiParser.js 统一解析
import * as api from '../services/perform_sales';
import * as mock from '../services/mock';
import {
  parseShowList,
  parseOverview,
  parseVip,
  parseVisitSalesTrend,
  parseFunnel,
  parseRegionTop,
  parseSessionStack,
  parseChannel,
} from '../utils/apiParser';

// 真实接口上线后请把所有 useMock 改为 false
const useMock = false;

export default {
  namespace: 'performSales',

  state: {
    // 查询条件
    proNo: '',
    dateStart: null,
    dateEnd: null,
    // 剧目下拉
    playList: [],
    // 销售总览
    overview: {},
    // VIP
    vip: {},
    // 访问与销售趋势（合并 PV/UV/PAID/早鸟）
    trend: { labels: [], pv: [], uv: [], paid: [], earlyBird: [] },
    // 购票漏斗
    funnel: { detailUv: 0, tsjBuyers: 0, detailConv: 0, funnel: [] },
    // 访问地域 TOP5
    geoTop5: { pvTotal: 0, localShare: 0, outsideShare: 0, geo: [] },
    // 分场次销售
    sessions: {
      totalCount: 0,
      totalSold: 0,
      totalRemain: 0,
      sessions: [],
    },
    // 售票渠道
    channelSplit: {
      wentIncluded: false,
      rows: [],
      totalTickets: 0,
      totalAmountWan: 0,
    },
  },

  effects: {
    // 0. 剧目下拉
    *getPlayList({ payload }, { call, put }) {
      const fn = useMock ? mock.mockQueryShowList : api.queryShowList;
      const res = yield call(fn, payload);
      yield put({
        type: 'save',
        payload: { playList: parseShowList(res.data) },
      });
    },
    // 1. 销售总览
    *getShowOverview({ payload }, { call, put }) {
      const fn = useMock ? mock.mockQueryShowOverview : api.queryShowOverview;
      const res = yield call(fn, payload);
      yield put({
        type: 'save',
        payload: { overview: parseOverview(res.data) },
      });
    },
    // 2. VIP
    *getShowVip({ payload }, { call, put }) {
      const fn = useMock ? mock.mockQueryShowVip : api.queryShowVip;
      const res = yield call(fn, payload);
      yield put({ type: 'save', payload: { vip: parseVip(res.data) } });
    },
    // 3. 访问与销售趋势（合并）
    *getVisitSalesTrend({ payload }, { call, put }) {
      const fn = useMock
        ? mock.mockQueryShowVisitSalesTrend
        : api.queryShowVisitSalesTrend;
      const res = yield call(fn, payload);
      yield put({
        type: 'save',
        payload: { trend: parseVisitSalesTrend(res.data) },
      });
    },
    // 4. 购票漏斗
    *getShowFunnel({ payload }, { call, put }) {
      const fn = useMock ? mock.mockQueryShowFunnel : api.queryShowFunnel;
      const res = yield call(fn, payload);
      yield put({ type: 'save', payload: { funnel: parseFunnel(res.data) } });
    },
    // 5. 访问地域 TOP5
    *getShowRegionTop({ payload }, { call, put }) {
      const fn = useMock ? mock.mockQueryShowRegionTop : api.queryShowRegionTop;
      const res = yield call(fn, payload);
      yield put({
        type: 'save',
        payload: { geoTop5: parseRegionTop(res.data) },
      });
    },
    // 6. 分场次销售
    *getShowSessionStack({ payload }, { call, put }) {
      const fn = useMock
        ? mock.mockQueryShowSessionStack
        : api.queryShowSessionStack;
      const res = yield call(fn, payload);
      yield put({
        type: 'save',
        payload: { sessions: parseSessionStack(res.data) },
      });
    },
    // 7. 售票渠道
    *getShowChannel({ payload }, { call, put }) {
      const fn = useMock ? mock.mockQueryShowChannel : api.queryShowChannel;
      const res = yield call(fn, payload);
      yield put({
        type: 'save',
        payload: { channelSplit: parseChannel(res.data) },
      });
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {},
};
